module.exports = __webpack_public_path__ + "img/PS42.91ef8927.png";